import type { ExpenseRow, ExpenseSettlementListRow, ExpenseSettlementRow } from './expenseTypes';
import { formatLocalTime } from '@shared/vueltoDateTime';
import { formatMoney } from '../../shared/format/public-api';
import { expenseErpCopy } from './expenseErpCopy';

export { expenseErpCopy };

// Moneda canónica es-AR ($1.000 / $1.500,50) — misma convención que el resto de la app.
export function formatExpenseMoney(n: number): string {
  return formatMoney(n);
}

/**
 * Fecha de gasto/factura (YYYY-MM-DD, día de calendario sin hora) → DD/MM/YYYY.
 * No usar `formatLocalDate` sobre date-only: `new Date('YYYY-MM-DD')` es UTC
 * midnight y en UTC-3 muestra el día anterior.
 */
export function formatExpenseDate(isoDate: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec((isoDate ?? '').trim());
  if (!m) return isoDate?.trim() || '—';
  return `${m[3]}/${m[2]}/${m[1]}`;
}

/** DD/MM — versión corta para metas de filas (el año casi siempre es el actual). */
export function formatExpenseDateShort(isoDate: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec((isoDate ?? '').trim());
  if (!m) return isoDate?.trim() || '—';
  return `${m[3]}/${m[2]}`;
}

/** DD/MM HH:mm — proto mini-row de pagos en el detalle. */
export function formatExpenseDateTimeShort(iso: string | null | undefined): string {
  const date = formatExpenseDateShort(iso);
  const time = formatLocalTime(iso);
  if (time === '—') return date;
  if (date === '—') return time;
  return `${date} ${time}`;
}

export function expensePaymentStatusLabel(status: ExpenseRow['paymentStatus']): string {
  return expenseErpCopy.paymentStatus[status];
}

export function expenseAmountResidual(amount: number, amountPaid: number): number {
  return Math.max(0, amount - amountPaid);
}

export function expenseSettlementMethodLabel(
  method: ExpenseSettlementRow['method'] | ExpenseSettlementListRow['method']
): string {
  if (method === 'cash_drawer') return 'Efectivo de la caja';
  if (method === 'transfer') return 'Transferencia';
  if (method === 'card') return 'Tarjeta';
  if (method === 'check') return 'Cheque';
  return 'Otro';
}

export function expenseSettlementStatusLabel(
  status: ExpenseSettlementListRow['settlementStatus']
): string {
  return status === 'voided' ? 'Anulado' : 'Activo';
}
